export const getDateLocale = (locale) =>
  import(`date-fns/locale/${locale === 'en' ? 'en-GB' : locale}/index.js`);
